import { render, staticRenderFns } from "./bankInfoList.vue?vue&type=template&id=c5703b08&scoped=true"
import script from "./bankInfoList.vue?vue&type=script&lang=js"
export * from "./bankInfoList.vue?vue&type=script&lang=js"
import style0 from "./bankInfoList.vue?vue&type=style&index=0&id=c5703b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5703b08",
  null
  
)

export default component.exports